import axios from "axios";

class RegisterService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_PROFILE_MULTIPART_URL;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }

    registerEbuUser(firstName , lastName , emailAddress , cellnumber , landline , businessName, jobTitle , vodacomAccNumber , captcha ,
                    documentTitle, idNumber, fileName, fileBuffer, accountType, selectedFile) {

        let params =  new URLSearchParams({
            "firstName": firstName,
            "lastName": lastName,
            "emailAddress": emailAddress,
            "cellnumber": cellnumber,
            "landline": landline,
            "businessName": businessName,
            "jobTitle": jobTitle,
            "vodacomAccNumber": vodacomAccNumber,
            "captcha": captcha,
            "idNumber": idNumber
        }).toString();

        if (accountType === "gsm") {
            const formData = new FormData();
            formData.append('file', selectedFile);
            return this.restClient.post('/registration/gsm/register?' + params, formData, {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            });
        } else {
            return this.restClient.post('/registration/fixed/register?' + params);
        }
    }

}

export default new RegisterService();
